export default {
  UPDATE_COLLEGE_COMPARE: 'UPDATE_COLLEGE_COMPARE',
  CLEAR_COLLEGE_COMPARE: 'CLEAR_COLLEGE_COMPARE',
}
